<template>
  <div class="wrapper">
    <cube-scroll
    ref="scroll"
    :data="schedulelist">
      <div  class="time-wrapper" v-for="item in schedulelist" :key="item.id">
        <div class="info-content">
          <div class="time">{{item.time}}</div>
          <div class="week">{{_getWeekDay(item.week)}}</div>
          <div class="server">{{item.startTime}}-{{ item.endTime }}</div>
        </div>
        <div class="button" @click="editInfo(item)">预约</div>
      </div>
       <div class="no-data" v-if="!schedulelist || schedulelist.length === 0">暂无时间</div>
    </cube-scroll>
  </div>
</template>

<script>
import { getScheduleByDocId, addOrder } from '@/api/yuyueApi'
let docId = ''
export default {
  components: {},
  props: {},
  data () {
    return {
      schedulelist: []
    }
  },
  watch: {},
  computed: {},
  methods: {

    async editInfo  (item) {
      const params = {
        doctorId: docId,
        scheduleId: item.id
      }
      const res = await addOrder(params)
      console.log(res)
      if (res.reason) {
        this.$router.push({
          path: '/editInfo',
          query: {
            id: res.reason
          }
        })
      } else {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: res.message
        }).show()
      }
    },
    async getSchedule (docId) {
      const params = {
        doctorId: docId
      }
      const res = await getScheduleByDocId(params)

      this.schedulelist = res.obj
    },

    _getWeekDay (num) {
      const weeks = {
        1: '周日',
        2: '周一',
        3: '周二',
        4: '周三',
        5: '周四',
        6: '周五',
        7: '周六'
      }
      return weeks[parseInt(num)]
    }
  },
  created () {
    docId = this.$route.query.docId
    console.log(docId)
    if (!docId) {
      this.$createDialog({
        type: 'alert',
        title: '缺少参数',
        content: 'docId错误'
      }).show()
      return
    }
    // const docId = '55fae71e0cf25f84104de1e0'
    this.getSchedule(docId)
  },
  mounted () {}
}
</script>
<style lang="stylus" scoped>
.wrapper {
  position absolute
  left 0
  top 0
  bottom 0
  right 0
  font-size 14px
  background-color #272c2d
  .no-data {
    text-align center
    width 100%
    color white
    height 100px
    line-height 100px
    font-size 18px
  }
}
.time-wrapper {
  display flex
  align-items center
  padding 0 10px
  height 60px
  border-bottom 1PX solid rgba(255,255,255,0.1)
  .info-content {
    flex 1
    display flex
    justify-content space-between
    margin-right 20px
    color white
    .time {
      min-width 100px
    }
    .week {
      width 40px
      text-align center
    }
    .server {
      min-width 80px
    }
  }

  .button {
    flex 0 0 60px
    width 60px
    background-color #fbf144
    text-align center
    height 35px
    line-height 35px
    border-radius 30px
  }
}
</style>
